import { connect } from "react-redux";

import { getOfficesShortList } from "../../Offices/officesActions";
import { getOrganizationMembersList } from "../../Projects/projectsActions";
import { getWorkOrderShortList } from "../../WorkOrderNew/workOrderActions";
import { getJobDetails, getJobList, updateJobApproval } from "../jobsActions";
import { getTasksList, updateTaskApproval } from "../tasksActions";
// Component
import JobApproval from "./JobApproval";

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  duplicateIsLoading: state.task.duplicateIsLoading,
  deleteIsLoading: state.task.deleteIsLoading,
  deletedCallback: state.task.deletedCallback,
  tasksList: state.task.tasksList,
  createdTaskInfo: state.task.createdTaskInfo,
  duplicateTaskInfo: state.task.duplicateTaskInfo,
  isLoading: state.task.isLoading,
  loadingTaskAssigneeId: state.project.loadingTaskAssigneeId,
  // pagination
  totalTasksCount: state.task.tasksListCount,
  pageSize: state.task.taskListPageSize,
  // jobs
  isLoadingJobs: state.jobs.isLoadingJobs,
  totaljobsCount: state.jobs.totaljobsCount,
  pageSizeJob: state.jobs.pageSizeJob,
  reloadJobList: state.jobs.reloadJobList,
  jobList: state.jobs.jobList,
  //workordershort
  workOrderShortList: state.workorder.workOrderShortList,
  // job Details
  jobDetailsLoading: state.jobs.getJobIsLoading,
  jobDetails: state.jobs.jobDetails,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getTasksList: params => dispatch(getTasksList(params)),
  getOfficesShortList: params => dispatch(getOfficesShortList(params)),
  updateTaskApproval: params => dispatch(updateTaskApproval(params)),
  //
  getWorkOrderShortList: params => dispatch(getWorkOrderShortList(params)),
  getJobList: params => dispatch(getJobList(params)),
  updateJobApproval: params => dispatch(updateJobApproval(params)),
  getJobDetails: details => dispatch(getJobDetails({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(JobApproval);
